export default "__VITE_ASSET__Cd3tkvc8__"